//core
import React from 'react';
//types
import {IFacility} from 'types/facility';

interface IProps {
  facilities: Array<IFacility>;
  facility: string;
  setFacility: React.Dispatch<string>;
}

export default function FacilityFilter({facilities, facility, setFacility}: IProps) {
  const realFacilities = facilities.filter((f) => !f.virtual);

  return (
    <div className="d-flex justify-content-center mb-3 px-3">
      {realFacilities.length > 1 && (
        <select className="form-control" value={facility} onChange={(e) => setFacility(e.target.value)}>
          {realFacilities.map((f) => (
            <option key={f.key} value={f.key}>
              {f.name}
            </option>
          ))}
        </select>
      )}
      {realFacilities.length === 1 && <h2 className="m-0">{facilities[0].name}</h2>}
    </div>
  );
}
